import pino from "pino";

export const log = pino();